import { useContext, useState } from 'react';
import { Box, IconButton, Menu, MenuItem, Typography, useTheme } from "@mui/material";
import { ColorModeContext, tokens } from '../../theme';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { UserContext } from '../../context/UserContext';
import { useNavigate } from 'react-router-dom';
import NotificationDialog from './NotificationDialog';

function Topbar() {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const colorMode = useContext(ColorModeContext);
    const { setToken, user } = useContext(UserContext);
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState(null);
    const openSettingsMenu = Boolean(anchorEl);
    const handleSettingsMenuButtonClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleSettingsMenuClose = () => {
        setAnchorEl(null);
    };

    const [notificationsDialogOpen, setNotificationsDialogOpen] = useState(false);

    return (
        <Box display="flex" justifyContent="space-between" p={2}>
            {
                user.type === "admin" &&
                <>
                    <Menu
                        id="settings-menu"
                        anchorEl={anchorEl}
                        open={openSettingsMenu}
                        onClose={handleSettingsMenuClose}
                        MenuListProps={{
                            'aria-labelledby': 'settings-button',
                        }}
                    >
                        <MenuItem onClick={() => {
                            setNotificationsDialogOpen(true);
                            handleSettingsMenuClose();
                        }}>
                            <Typography color={colors.grey[100]}>Bildirim Gönder</Typography>
                        </MenuItem>
                    </Menu>
                    {notificationsDialogOpen &&
                        <NotificationDialog open={notificationsDialogOpen} handleClose={() => setNotificationsDialogOpen(false)} />
                    }
                </>
            }
            {/* LOGO */}
            <h2>ALCAGO</h2>


            {/* ICONS */}
            <Box display="flex">
                {user.type === "brand" &&
                    // bakiye gösterimi ve yüklemek için + butonu
                    <Box display="flex" alignItems="center" justifyContent="center" marginRight="15px">
                        <Typography variant="h6" color={colors.greenAccent[500]} fontWeight="bold" sx={{ marginRight: "10px" }}>
                            Bakiye: {user.balance.toFixed(2)} ₺
                        </Typography>
                        <IconButton
                            sx={{
                                backgroundColor: colors.greenAccent[700],
                                height: "30px",
                                width: "30px",
                                "&:hover": { backgroundColor: colors.greenAccent[600] },
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                            onClick={() => {
                                //TODO: bakiye yükleme dialogu
                            }}>
                            <Typography variant="h3" color={colors.primary[100]} fontWeight="bold">
                                +
                            </Typography>
                        </IconButton>
                    </Box>
                }
                <IconButton onClick={colorMode.toggleColorMode}>
                    {theme.palette.mode === 'dark' ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
                </IconButton>

                <IconButton onClick={() => navigate(`/${user.type}-panel/profile`)}>
                    <PersonOutlinedIcon />
                </IconButton>

                {user.type === "admin" &&
                    <IconButton onClick={handleSettingsMenuButtonClick}>
                        <SettingsOutlinedIcon />
                    </IconButton>
                }

                <IconButton onClick={() => { setToken(null); }}>
                    <LogoutOutlinedIcon />
                </IconButton>
            </Box>
        </Box>
    )
}

export default Topbar;